<template>
  <!-- 解析器 -->
  <div >
    <div >
      <div class="mb10">
        <v-button class="" type="primary" name="" @click="showNewModel">创建解析器</v-button>
      </div>
      <div>
        <vxe-table
          row-id="id"
          :data="table"
          align="left"
          :row-style="setRowClass"
        >
          <vxe-table-column  field="analysis_name" show-overflow min-width="120" title="解析器名称"></vxe-table-column>
          <vxe-table-column  field="SourceName" show-overflow min-width="120" title="数据源"></vxe-table-column>
          <vxe-table-column  field="DestName" show-overflow min-width="120" title="数据目的"></vxe-table-column>
          <vxe-table-column  field="" v-slot="slotProps" show-overflow min-width="120" title="状态">
            <span>
              <v-switch name="switch" v-model="slotProps.row.open_status" :on-value="1" :off-value="2" @change="changeSwitch( slotProps.row )"></v-switch>
            </span>
          </vxe-table-column>
          <vxe-table-column  field="analysis_desc" show-overflow min-width="120" title="描述"></vxe-table-column>
          <vxe-table-column  field="created_at" show-overflow min-width="120" title="创建时间"></vxe-table-column>
          <vxe-column title="操作" min-width="140">
              <template v-slot="slotProps">
                <span class="handle-button"><v-button size="S" type="text" name="btn1" slot="reference" @click="showUpdateModel(slotProps.row)">编辑</v-button></span>
                <span class="handle-button"><v-button size="S" type="text" name="btn2" slot="reference" @click="showDelModel(slotProps.row)">删除</v-button></span>
              </template>
          </vxe-column>
        </vxe-table>
      </div>
      <v-pagination v-if="total" @change-page="changePage" @change-size="changeSize" :total="total" name="page-basic" is-show-total is-change-size is-input-page :current-page="this.currentPage" ></v-pagination>
    </div>

    <New :showInputDialog.sync="Newloading" ref="New" @getData="getData"></New>
    <Del :showInputDialog.sync="Delloading" ref="Del" :Id="Id" @getData="getData"></Del>
    <Update :showInputDialog.sync="Updateloading" :infoData="infoData" @getData="getData" ref="Update"></Update>
  </div>
</template>

<script>
import New from "@/components/rule-engine/parse/new-parse.vue";
import Del from "@/components/rule-engine/parse/del.vue";
import Update from "@/components/rule-engine/parse/update-parse.vue";

export default {
components: {New, Del, Update},
data() {
  return {
    Newloading:false,
    Updateloading:false,
    Delloading: false,
    currentPage: 1,
    infoData:{},
    pageSize: 10,
    table: [],
    Id: '',
    total: 0
  };
},
created() {
  this.getData()
},
methods: {
  setRowClass({rowIndex}){
   if( rowIndex%2!==0){
      return "background: #fafafa";
   }
  },
  async getData(){
    const subData = {
      app_id: sessionStorage.getItem("appid") || "",
      page_num: this.currentPage,
      page_size: this.pageSize,
      search:''
    };
    const res = await this.$getData(
      "/td/td-iot-api/iot/rule/analysis/list/v1",
      subData
    );
    if(res.code === 0){
      this.table = res.data.list
      // this.table.map((item)=>{
      //   item.open_status_view = item.open_status == 1 ? '开启' : '关闭'
      // })
      this.total = res.data.page_result.total
    }else{
      if(res.code == '100410'){
        setTimeout(() => {
          this.getData()
        },1000)
      }else{
        this.$message.error(res.msg);
      }
    }
  },

  changePage(page){
    this.currentPage = Number(page)
    this.getData()
  },
  changeSize(size){
    this.pageSize = Number(size)
    this.currentPage = 1
    this.getData()
  },
  showNewModel(){
    this.Newloading = !this.Newloading
  },
  showDelModel(row){
    this.Id = row.id
    this.Delloading = !this.Delloading
  },
  showUpdateModel(row) {
    this.infoData = row
    this.Updateloading = !this.Updateloading;
  },
  changeSwitch(row){
    const submitData = {
      id: row.id,
      open_status: row.open_status,
    }
    this.$put("/td/td-iot-api/iot/rule/analysis/switch/v1", submitData, false).then((res) => {
      let code = +res.code;
      if (code === 0) {
        this.getData()
      }else {
        this.getData()
        this.$message.error(res.msg);
      }
    });
  }
},
beforeDestroy() {},
};
</script>
<style lang="scss">
  .low-title{
    font-size: 18px;
  }
</style>
